<template>
  <div>
    <md-card>
      <md-card-header class="md-card-header-icon md-card-header-primary">
        <div class="card-text">
          <h4 class="title">
            Notes
          </h4>
        </div>
        <add-button
          :visible="canAddNote()"
          @add-click="showNoteModal = true"
        ></add-button>
      </md-card-header>
      <md-card-content>
        <div
          class="md-layout-item md-medium-size-100 md-xsmall-size-100 md-size-100"
        >
          <time-line plain type="simple">
            <time-line-item
              v-for="noteItem in quote.notes"
              :key="noteItem.id"
              :value="noteItem.id"
              inverted
              :badge-type="quoteStatus(noteItem.statusId).colour"
              :badge-icon="noteIcon(noteItem.noteTypeId)"
            >
              <p slot="content">
                {{ noteItem.note }}
              </p>

              <h6 slot="footer">
                <i class="ti-time text-gray">
                  {{ noteItem.createdDate | moment("MMMM Do YYYY HH:mm") }}
                  - {{ noteItem.createdBy }}</i
                >
              </h6>
            </time-line-item>
          </time-line>
        </div>
      </md-card-content>
    </md-card>
    <QuoteNoteForm
      :showModal="showNoteModal"
      @closeModal="closeModal"
    ></QuoteNoteForm>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import { TimeLine, TimeLineItem } from "@/components";

export default {
  components: {
    TimeLine,
    TimeLineItem,
    QuoteNoteForm: () => import("./QuoteNoteForm")
  },
  data() {
    return {
      showNoteModal: false
    };
  },
  computed: {
    ...mapGetters({
      quote: "quote/quote",
      quoteStatus: "quote/getQuoteStatus",
      noteIcon: "noteIcons"
    })
  },
  methods: {
    canAddNote() {
      return this.quote.quoteStatus < 5 && this.quote.state === 1;
    },
    closeModal(refresh) {
      this.showNoteModal = false;
      if (refresh) this.$emit("refresh");
    }
  }
};
</script>

<style></style>
